import { useEffect, useState } from 'react';

import FieldViewAsToggle from '@atom/components/common/fieldViewAsToggle/FieldViewAsToggle';
import { Modal } from '@atom/mui';
import { FieldViewType } from '@atom/types/dataType';
import { TaskField, TaskFieldUpdatePayload } from '@atom/types/task';
import { WorkOrderTemplateTaskFieldUpdatePayload } from '@atom/types/workTemplate';

type TaskFieldEditListViewModalProps = {
  field: TaskField | null;
  open: boolean;
  handleUpdate: (
    payload: TaskFieldUpdatePayload | WorkOrderTemplateTaskFieldUpdatePayload,
  ) => void;
  onClose: () => void;
  loadingUpdate?: boolean;
};

const TaskFieldEditListViewModal = ({
  field,
  handleUpdate,
  open,
  onClose,
  loadingUpdate,
}: TaskFieldEditListViewModalProps) => {
  const [viewAs, setViewAs] = useState<FieldViewType | null>(
    field?.viewAs ?? null,
  );

  useEffect(() => {
    if (open) {
      setViewAs(field?.viewAs ?? null);
    }
  }, [open, field]);

  const handleSubmit = () => {
    handleUpdate({
      fieldId: field.id,
      // An empty string clears a list view back to dropdown
      viewAs: viewAs ?? '',
    });
  };

  return (
    <Modal
      title="Edit Field"
      open={open}
      onCancel={onClose}
      onConfirm={handleSubmit}
      confirmButtonText="Save"
      loading={loadingUpdate}
      disabled={viewAs === (field?.viewAs ?? null)}
      CancelButtonProps={{ 'data-cy': 'taskFieldEditListViewModalCancel' }}
      ConfirmButtonProps={{ 'data-cy': 'taskFieldEditListViewModalSave' }}
      data-cy="taskFieldEditListViewModal"
    >
      <FieldViewAsToggle
        viewAs={viewAs}
        onChange={setViewAs}
        optionCount={field?.enumeration?.length}
        dataCy="taskFieldEditListViewModalViewAsToggle"
      />
    </Modal>
  );
};

export default TaskFieldEditListViewModal;
